/**
 * Blog Post Custom JS — Copper Bridge USA
 * Progress bar, sticky shop bar, FAQ accordion
 * Safe to load on all article pages (null-checks all elements)
 */
document.addEventListener('DOMContentLoaded', function () {

  /* ── Progress Bar ── */
  var progressBar = document.getElementById('progress-bar');
  if (progressBar) {
    window.addEventListener('scroll', function () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      progressBar.style.width = scrollPercent + '%';
    });
  }

  /* ── Sticky Shop Bar ── */
  var stickyBar = document.getElementById('sticky-bar');
  var stickyClose = document.getElementById('sticky-close');
  if (stickyBar) {
    var stickyDismissed = false;
    window.addEventListener('scroll', function () {
      if (stickyDismissed) return;
      if (window.pageYOffset > 600) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    });
    if (stickyClose) {
      stickyClose.addEventListener('click', function () {
        stickyDismissed = true;
        stickyBar.classList.remove('visible');
      });
    }
  }

  /* ── FAQ Accordion ── */
  var faqQuestions = document.querySelectorAll('.faq-question');
  if (faqQuestions.length > 0) {
    faqQuestions.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parent = this.parentElement;
        var isOpen = parent.classList.contains('active');

        // Close all other FAQ items
        document.querySelectorAll('.faq-item.active').forEach(function (item) {
          item.classList.remove('active');
        });

        // Toggle clicked item
        if (!isOpen) {
          parent.classList.add('active');
        }
      });
    });
  }

});
